import { useContext } from 'react';
import { AgentsSearchParamsContext } from '~/contexts/AgentSearchParamsContext';
import { CompanyTrendsSearchParamsContext } from '~/contexts/CompanyTrendsSearchParamsContext';
import { LoanOfficersSearchParamsContext } from '~/contexts/LoanOfficerSearchParams';
import { OpportunitiesSearchParamsContext } from '~/contexts/OpportunitySearchParamsContext';
import { TeamsSearchParamsContext } from '~/contexts/TeamsSearchParamsContext';

export const useLoanOfficersSearchParams = () => {
  const searchParamsProps = useContext(LoanOfficersSearchParamsContext);

  return searchParamsProps;
};

export const useCompanyTrendsSearchParams = () => {
  const searchParamsProps = useContext(CompanyTrendsSearchParamsContext);

  return searchParamsProps;
};

export const useAgentsSearchParams = () => {
  const searchParamsProps = useContext(AgentsSearchParamsContext);

  return searchParamsProps;
};

export const useOpportunitiesSearchParams = () => {
  const searchParamsProps = useContext(OpportunitiesSearchParamsContext);

  return searchParamsProps;
};

export const useTeamsSearchParams = () => {
  const searchParamsProps = useContext(TeamsSearchParamsContext);

  return searchParamsProps;
};
